var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar",class:[_vm.collapse&&'sidebarCol']},[_c('div',{staticClass:"sidebar_logo",on:{"click":_vm.toProduct}},[_c('Logo')],1),_c('OEMMenu',{ref:"menu"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }